import {
    ContractTree,
    ContractTreeRow,
} from '@thought-river/negotiations-common/dist/api/contractManagement';
import { QueryClient } from '@tanstack/react-query';

//Update a contract row in a list of contracts
export const updateTanStackQueryContractsRow = (
    queryClient: QueryClient,
    newRow: ContractTreeRow
) => {
    queryClient.setQueryData(
        ['contracts'],
        (oldData: ContractTree | undefined) =>
            oldData
                ? {
                      ...oldData,
                      rows: oldData.rows.map((row) =>
                          row.id === newRow.id ? newRow : row
                      ),
                  }
                : oldData
    );
};
